import React, { useState, useEffect } from "react";
import { Table, Tag, Input, Select, Button, Modal, Checkbox, message } from "antd";
import { SearchOutlined, EditOutlined, CloseOutlined, DownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./index.scss"; // Assuming SCSS is supported, else inline styles or just .css
/* eslint-disable no-unused-vars */
const { Option } = Select;
import Link from "antd/es/typography/Link";
import API from "../../api";
import urls from "../../api/urls";
import constants from "../../constants/constants";
import AddCircleWhite from "../../assests/images/add-circle-white.svg";
import back_img from "../../assests/images/rightVector.svg";
import Smcs_Loader from "../../assests/images/loader-new.gif";

const HubAccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userinfo = localStorage.getItem("userinfo");
    if (userinfo) {
      const parsed = JSON.parse(userinfo);
      //console.log("Token:", parsed.accessToken);
    } else {
      console.log("No userinfo found in localStorage");
    }
  }, []);

  // Hub List State
  const [allAvailableHubs, setAllAvailableHubs] = useState([]);
  const [filterType, setFilterType] = useState("name");
  // Role Filter State
  const [selectedRole, setSelectedRole] = useState(constants.ROLES.HUB_ADMIN);

  const fetchAllHubs = async (search = "", currentFilter = "name") => {
    try {
      let response;
      if (!search) {
        response = await API.Api(urls.GET_HUB_LISTS).getWithHeader();
      } else {
        const params = {
          page: 0,
          size: 1000,
          [currentFilter.toLowerCase()]: search
        };
        response = await API.Api(urls.GET_HUB_LIST_WITH_FILTER).getwithParams(params);
      }

      if (response && response.status && response.response && response.response.data) {
        let rawData = response.response.data;
        let dataList = [];

        if (Array.isArray(rawData)) {
          dataList = rawData;
        } else if (rawData.content && Array.isArray(rawData.content)) {
          dataList = rawData.content;
        } else if (rawData.data && Array.isArray(rawData.data)) {
          dataList = rawData.data;
        }

        // Map response to object with id and name
        const hubs = dataList.map((item) => ({
          id: item.premiseId,
          name: item.premiseName
        }));
        setAllAvailableHubs(hubs);
      }
    } catch (error) {
      console.error("Error fetching hub list:", error);
    }
  };

  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [hubSearchText, setHubSearchText] = useState("");

  // State for Add Hub Selection Modal
  const [isAddHubModalVisible, setIsAddHubModalVisible] = useState(false);
  const [tempSelectedHubs, setTempSelectedHubs] = useState([]); // Stores hub IDs
  const [hubSelectionSearchText, setHubSelectionSearchText] = useState("");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchAllHubs(hubSelectionSearchText, filterType);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [hubSelectionSearchText, filterType]);

  const showAllHubs = (hubs) => {
    setSelectedHubs(hubs);
    setIsModalVisible(true);
  };

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editHubs, setEditHubs] = useState([]);

  const showEditModal = (record) => {
    setEditingUser(record);
    setEditHubs(record.assignedHubs); // specialized state for editing
    setIsEditModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedHubs([]);
  };

  const handleEditCancel = () => {
    setIsEditModalVisible(false);
    setEditingUser(null);
    setEditHubs([]);
    setHubSearchText("");
  };

  const handleAddHub = () => {
    // This seems to be for searching and adding by name in the Edit modal directly (optional legacy flow?)
    // Checking if entered text matches a known hub name
    const foundHub = allAvailableHubs.find(h => h.name.toLowerCase() === hubSearchText.trim().toLowerCase());
    if (foundHub) {
      const alreadyExists = editHubs.some(h => h.id === foundHub.id);
      if (!alreadyExists) {
        setEditHubs([...editHubs, { id: foundHub.id, name: foundHub.name }]);
        setHubSearchText("");
      }
    }
  };

  // This function might need updates if we want to save from the Edit Modal too, but the user request focused on "Add Hubs" button in "All Hub pop"
  // This function might need updates if we want to save from the Edit Modal too, but the user request focused on "Add Hubs" button in "All Hub pop"
  const handleSaveChanges = async () => {
    if (!editingUser || !editingUser.email) return;

    // Use IDs directly from hub objects
    const currentHubIds = editHubs.map(h => h.id).filter(Boolean);

    if (currentHubIds.length === 0) {
      message.error("Please Add Hub");
      return;
    }

    try {
      const payload = {
        hubIds: currentHubIds
      };
      const response = await API.Api(`${urls.ASSIGN_HUBS}${editingUser.email}`).putPremiseIdHeader(payload);

      if (response.status) {
        setIsEditModalVisible(false);
        setEditingUser(null);
        setEditHubs([]);
        setHubSearchText("");
        fetchHubAccessData(pagination.current, pagination.pageSize);
      } else {
        console.error("Failed to save changes:", response);
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  // --- Handlers for Add Hub Selection Modal ---

  const openAddHubModal = () => {
    // Pre-select hubs that are already assigned (matching by ID)
    const existingHubIds = editHubs.map(h => h.id);

    setTempSelectedHubs(existingHubIds);
    setIsAddHubModalVisible(true);
  };

  const closeAddHubModal = () => {
    setIsAddHubModalVisible(false);
    setTempSelectedHubs([]);
    setHubSelectionSearchText("");
  };

  const toggleHubSelection = (hubId) => {
    if (tempSelectedHubs.includes(hubId)) {
      setTempSelectedHubs(tempSelectedHubs.filter(id => id !== hubId));
    } else {
      setTempSelectedHubs([...tempSelectedHubs, hubId]);
    }
  };

  const handleAddAllHubs = (e) => {
    if (e.target.checked) {
      // Add all filtered hubs that are not already selected
      const hubsToAdd = filteredAvailableHubs
        .filter(hub => !tempSelectedHubs.includes(hub.id))
        .map(hub => hub.id);
      setTempSelectedHubs([...tempSelectedHubs, ...hubsToAdd]);
    } else {
      // Deselect all currently filtered hubs
      const filteredIds = filteredAvailableHubs.map(h => h.id);
      const newSelection = tempSelectedHubs.filter(id => !filteredIds.includes(id));
      setTempSelectedHubs(newSelection);
    }
  };

  const confirmAddHubs = () => {
    if (tempSelectedHubs.length === 0) {
      message.warning("At least one hub must be selected.");
      return;
    }

    // We need to construct the full list of objects for tempSelectedHubs.
    // Sources:
    // 1. Current editHubs (has objects for already assigned hubs)
    // 2. allAvailableHubs (has objects for newly selected hubs from current search)

    // Create a map of ID -> HubObject from both sources
    const pool = {};
    editHubs.forEach(h => { pool[h.id] = h; });
    allAvailableHubs.forEach(h => { pool[h.id] = { id: h.id, name: h.name }; });

    const newEditHubs = tempSelectedHubs.map(id => pool[id]).filter(obj => obj);

    setEditHubs(newEditHubs);
    closeAddHubModal();
  };

  // Server-side filtering is used, so we use the fetched list directly
  const filteredAvailableHubs = allAvailableHubs;

  const handleRemoveHub = (hubToRemove) => {
    if (editHubs.length <= 1) {
      message.warning("At least one hub must remain assigned.");
      return;
    }
    setEditHubs(editHubs.filter(hub => hub.id !== hubToRemove.id));
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <span style={{ color: "#101828", fontWeight: "500" }}>{text}</span>
      ),
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Assigned Hubs",
      dataIndex: "assignedHubs",
      key: "assignedHubs",
      width: "40%",
      render: (hubs) => (
        <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", overflow: "hidden", alignItems: "center" }}>
          {hubs.slice(0, 3).map((hub, index) => (
            <Tag color="purple" key={index} style={{ color: "#6941C6", background: "#F9F5FF", border: "1px solid #E9D7FE", borderRadius: "16px", padding: "2px 10px", margin: 0, whiteSpace: "nowrap" }}>
              {hub.name}
            </Tag>
          ))}
          {hubs.length > 3 && (
            <Tag
              color="blue"
              style={{ color: "#3538CD", background: "#EEF4FF", border: "1px solid #C7D7FE", borderRadius: "16px", padding: "2px 8px", margin: 0, cursor: "pointer" }}
              onClick={() => showAllHubs(hubs)}
            >
                            +{hubs.length - 3}
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      render: (_, record) => (
        <EditOutlined
          style={{ fontSize: "18px", color: "#667085", cursor: "pointer" }}
          onClick={() => showEditModal(record)}
        />
      ),
      align: "right",
    },
  ];



  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
  });

  useEffect(() => {
    fetchHubAccessData(1, pagination.pageSize);
  }, [selectedRole]);

  const fetchHubAccessData = async (page = 1, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await API.Api(urls.GET_USER_LIST).getwithParams({
        //search: "CHENNAI",
        role: selectedRole,
        page: page - 1, // API is 0-indexed
        size: pageSize
      });
      //console.log("Hub Access Data:", response);
      if (response && response.status && response.response && response.response.data && response.response.data.data && response.response.data.data.userList) {
        const apiData = response.response.data.data.userList.map((item, index) => ({
          key: index.toString(),
          name: item.name === null ? "--" : item.name,
          email: item.emailId || "--",
          role: item.roleName || "--",
          assignedHubs: item.linkedHubs ? item.linkedHubs.map(h => ({
            id: h.hubId || h.premiseId,
            name: h.hubName || h.premiseName
          })) : []
        }));
        setData(apiData);
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize: pageSize,
          total: response.response.data.data.totalElements || 0,
        }));
      } else {
        console.error("Invalid response structure:", response);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching Hub Access data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    fetchHubAccessData(newPagination.current, newPagination.pageSize);
  };



  const filteredData = data.filter((item) => {
    const searchLower = searchText.toLowerCase();
    return (
      item.name.toLowerCase().includes(searchLower) ||
            item.email.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div style={{ padding: "20px", background: "#F8FAFC", minHeight: "100vh" }}>
      <div style={{ background: "#fff", padding: "16px 24px", borderRadius: "8px", boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)" }}>
        {/* Header */}
        <div style={{ marginBottom: "24px", display: "flex", alignItems: "center" }}>
          <img src={back_img} onClick={() => navigate(-1)} style={{ cursor: "pointer", marginRight: "8px" }} alt="back" />
          <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#101828" }}>Hub Access</h1>
        </div>

        {/* Filters */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "24px" }}>
          <Input
            prefix={<SearchOutlined style={{ color: "#667085" }} />}
            placeholder="Search"
            style={{ flex: 1, marginRight: "16px", borderRadius: "8px" }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            className="custom-height-input"
          />
          <Select
            value={selectedRole}
            onChange={(value) => setSelectedRole(value)}
            style={{ width: 200 }}
            className="custom-height-input"
            dropdownStyle={{ borderRadius: "8px" }}
          >
            <Option value={constants.ROLES.HO_ADMIN}>HO ADMIN</Option>
            <Option value={constants.ROLES.HUB_ADMIN}>HUB ADMIN</Option>
            <Option value={constants.ROLES.ROLE_ZONALHEAD}>ZONAL HEAD</Option>
            <Option value={constants.ROLES.ROLE_CENTRALOPERATOR}>CENTRAL OPERATOR</Option>
          </Select>
        </div>

        {/* Table */}
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={pagination}
          onChange={handleTableChange}
          rowClassName="hub-access-table-row"
          loading={{
            spinning: loading,
            indicator: <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} alt="Loading..." />
          }}
        />

        {/* Modal for displaying all assigned hubs (View Only) */}
        <Modal
          title="Assigned Hubs"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {selectedHubs.map((hub, index) => (
              <Tag color="purple" key={index} style={{ color: "#6941C6", background: "#F9F5FF", border: "1px solid #E9D7FE", borderRadius: "16px", padding: "4px 12px", margin: 0 }}>
                {hub.name}
              </Tag>
            ))}
          </div>
        </Modal>

        {/* Modal for Editing Assigned Hubs */}
        <Modal
          title={`Assigned Hubs (${editHubs.length})`}
          visible={isEditModalVisible}
          onCancel={handleEditCancel}
          footer={null}
          width={600}
        >
          <div style={{ display: "flex", gap: "12px", marginBottom: "24px" }}>
            <Input
              placeholder="Search Hub..."
              style={{ borderRadius: "6px" }}
              value={hubSearchText}
              onChange={(e) => setHubSearchText(e.target.value)}
              onPressEnter={handleAddHub}
              allowClear
            />
            <Button
              type="primary"
              style={{ background: "#175EB6", borderRadius: "6px" }}
              icon={<img src={AddCircleWhite} alt="add" style={{ marginRight: "5px" }} />}
              onClick={openAddHubModal}
            >
                            Add Hub
            </Button>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "24px", maxHeight: "300px", overflowY: "auto" }}>
            {editHubs
              .filter((hub) => hub.name.toLowerCase().includes(hubSearchText.toLowerCase()))
              .map((hub, index) => (
                <Tag
                  key={index}
                  closable={editHubs.length > 1}
                  onClose={(e) => {
                    e.preventDefault();
                    handleRemoveHub(hub);
                  }}
                  style={{
                    color: "#6941C6",
                    background: "#F9F5FF",
                    border: "1px solid #E9D7FE",
                    borderRadius: "16px",
                    padding: "6px 14px",
                    margin: 0,
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px"
                  }}
                >
                  {hub.name}
                </Tag>
              ))}

          </div>

          <Button type="primary" block style={{ height: "44px", borderRadius: "8px", background: "#175EB6", fontSize: "16px", fontWeight: "600" }} onClick={handleSaveChanges}>
                        Save Changes
          </Button>
        </Modal>

        {/* Modal for Selecting Hubs to Add */}
        <Modal
          title={null}
          visible={isAddHubModalVisible}
          onCancel={closeAddHubModal}
          footer={null}
          width={800}
          bodyStyle={{ padding: "24px" }}
          closeIcon={null}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
            {/* Custom Header Layout */}
          </div>

          <div style={{ display: "flex", gap: "16px", marginBottom: "24px" }}>
            <Select
              defaultValue="name"
              style={{ width: 150 }}
              suffixIcon={<DownOutlined />}
              onChange={(value) => {
                setFilterType(value);
                setHubSelectionSearchText("");
              }}
            >
              <Option value="name">Hub</Option>
              <Option value="state">State</Option>
              <Option value="zone">Zone</Option>
            </Select>
            <Input
              prefix={<SearchOutlined style={{ color: "#98A2B3" }} />}
              placeholder="Search"
              value={hubSelectionSearchText}
              onChange={(e) => setHubSelectionSearchText(e.target.value)}
              style={{ flex: 1, borderRadius: "6px" }}
              allowClear
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <span style={{ fontWeight: "600", fontSize: "16px", color: "#101828" }}>
                            All Hub ({filteredAvailableHubs.length})
            </span>
            <Checkbox
              onChange={handleAddAllHubs}
              checked={filteredAvailableHubs.length > 0 && filteredAvailableHubs.every(hub => tempSelectedHubs.includes(hub.id))}
            >
              <span style={{ color: "#175EB6", fontWeight: "600" }}>Add All Hubs</span>
            </Checkbox>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", maxHeight: "400px", overflowY: "auto", marginBottom: "24px" }}>
            {filteredAvailableHubs.map((hub, index) => {
              const isSelected = tempSelectedHubs.includes(hub.id);
              return (
                <Tag
                  key={index}
                  onClick={() => toggleHubSelection(hub.id)}
                  style={{
                    cursor: "pointer",
                    padding: "6px 14px",
                    borderRadius: "16px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    border: isSelected ? "1px solid #D1FADF" : "1px solid #F2F4F7",
                    background: isSelected ? "#ECFDF3" : "#F8FAFC",
                    color: isSelected ? "#027A48" : "#344054",
                    margin: 0
                  }}
                >
                  {hub.name}
                  {isSelected ? <CloseOutlined style={{ fontSize: "12px" }} /> : <PlusCircleOutlined style={{ fontSize: "14px", color: "#98A2B3" }} />}
                </Tag>
              );
            })}
          </div>

          <Button
            type="primary"
            block
            style={{ height: "44px", borderRadius: "8px", background: "#175EB6", fontSize: "16px", fontWeight: "600" }}
            onClick={confirmAddHubs}
          >
                        Add Hubs
          </Button>

        </Modal>
      </div>
    </div>
  );
};

export default HubAccess;
